import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { format } from 'date-fns'
import Card, { COLOR_VARIANTS } from 'components/card'
import { Carousel } from 'react-bootstrap'
import { numberToCurrency } from 'lib/money'
import { CONFIG, FREE_SHIPPING_THRESHOLD } from 'shared/constants'
import Link from 'components/link'
import { returnsPath, buyNowPayLaterExplanationPath } from 'lib/urls'
import {
  getEligibleForRegistryDiscount,
  getRegistryDiscountEndsAt,
} from 'registry/reducers'

export const BenefitsCarousel = ({
  availableCredit,
  isEligibleForRegistryDiscount,
  registryDiscountEndsAt,
}) => {
  return (
    <Card bgColor={COLOR_VARIANTS.BUBBLEGUM} className="pal">
      <Carousel controls={false} indicators={false} interval={3000}>
        {availableCredit > 0 && (
          <Carousel.Item className="text-inverse">
            <div className="h5 text-bold pvn mvn">
              You have {numberToCurrency(availableCredit)} in Babylist shop
              credit
            </div>
            <div className="small">Applies at checkout</div>
          </Carousel.Item>
        )}
        <Carousel.Item className="text-inverse">
          <div className="h5 text-bold pvn mvn">
            Free shipping on orders ${FREE_SHIPPING_THRESHOLD}+
          </div>
          <div className="small">
            and{' '}
            <Link
              className="text-inverse text-underline"
              url={returnsPath}
              newWindow
            >
              free returns
            </Link>{' '}
            on Babylist shop items
          </div>
        </Carousel.Item>
        <Carousel.Item className="text-inverse">
          <div className="h5 text-bold pvn mvn">
            Prep now, pay later with Afterpay or Klarna
          </div>
          <div className="small">
            <Link
              className="text-inverse text-underline"
              url={buyNowPayLaterExplanationPath}
              newWindow
            >
              Learn More
            </Link>
          </div>
        </Carousel.Item>
        {isEligibleForRegistryDiscount && (
          <Carousel.Item className="text-inverse">
            <div className="h5 text-bold pvn mvn">
              {CONFIG.store.registryDiscountPctDisplay} discount on Babylist
              store items
            </div>
            <div className="small">
              One time use. Expires{' '}
              {format(new Date(registryDiscountEndsAt), 'M/d/yyyy')}
            </div>
          </Carousel.Item>
        )}
      </Carousel>
    </Card>
  )
}

BenefitsCarousel.propTypes = {
  availableCredit: PropTypes.number.isRequired,
  isEligibleForRegistryDiscount: PropTypes.bool.isRequired,
  registryDiscountEndsAt: PropTypes.string.isRequired,
}

const mapStateToProps = (state) => {
  return {
    availableCredit: state.user?.availableCredit,
    isEligibleForRegistryDiscount: getEligibleForRegistryDiscount(state),
    registryDiscountEndsAt: getRegistryDiscountEndsAt(state),
  }
}

export default connect(mapStateToProps, undefined)(BenefitsCarousel)
